var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }